export default __webpack_public_path__ + "assets/37e36b.svg";